import { AssignerDto, ModificationStackDto, ModificationStackSpecDto, PublishedStackDto, StackStatusDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface ModificationStacksState {
  loading: LoadingState;
  modificationStacks: ModificationStackDto[];
  createdStack: ModificationStackDto | null;
  createLoading: LoadingState;
  getStatusLoading: LoadingState;
  updateLoading: LoadingState;
  selectedStack: ModificationStackDto | null;
  currentStatus: StackStatusDto | null;
  isCreateStackDialogOpened: boolean;
  errors?: string;
  publishResult: PublishedStackDto | null;
  publishLoading: LoadingState;
  isStackSpecsDialogOpened: boolean;
  specsLoading: LoadingState;
  specs: ModificationStackSpecDto | null;
  copiedSpecs: ModificationStackSpecDto | null;
  selectedAssigner: AssignerDto | null;
  downloadingState: LoadingState;
}

export const initialModificationStacks: ModificationStacksState = {
  loading: LoadingState.idle,
  createLoading: LoadingState.idle,
  getStatusLoading: LoadingState.idle,
  updateLoading: LoadingState.idle,
  createdStack: null,
  modificationStacks: [],
  selectedStack: null,
  currentStatus: null,
  isCreateStackDialogOpened: false,
  publishResult: null,
  publishLoading: LoadingState.idle,
  isStackSpecsDialogOpened: false,
  specsLoading: LoadingState.idle,
  specs: null,
  copiedSpecs: null,
  selectedAssigner: null,
  downloadingState: LoadingState.idle
};
